import React from 'react';

import * as S from './styles';

export default function Main({ children }) {
  return <S.Container>{children}</S.Container>;
}
